module.exports = __webpack_public_path__ + "static/10-thumb-70f21de475b87c4002f19164d67f892f.jpg";